import { fetchPostState } from '@iwoca/lapi-client/edge';
import { fetchPostApiIntroducerPortalIntroducerCustomerApplication } from '@iwoca/lapi-client/introducer_portal';
import { TApplicationRequestBodyDE } from 'components/Signup/helpers/applicationNormalisation';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { useAmplitude } from 'hooks/useAmplitude';
import { TGetStateResponseDataDE } from 'lendingApi/lapiOverrides.types';
import { useSearchParams } from 'react-router-dom';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';

export const useInitializeState = () => {
  const { trackEvent } = useAmplitude();
  const { introducerId: introducer_id } = useIntroducerContext();
  const [searchParams] = useSearchParams();

  const initializeStateAndApplication = async (
    state: TGetStateResponseDataDE,
    application: TApplicationRequestBodyDE,
    saveForLater: boolean = false,
  ) => {
    if (searchParams.get('__impersonate') && introducer_id) {
      state.impersonation = { introducer_id };
    }

    const stateResponse = await fetchPostState({
      body: {
        data: {
          ...state,
          ui: {
            tip_latest_signup_step: saveForLater ? 'new' : 'new/documents',
          },
        } as any,
      },
    });

    const stateKey = stateResponse.data?.state_key;

    if (stateKey && introducer_id) {
      const newApplication =
        await fetchPostApiIntroducerPortalIntroducerCustomerApplication({
          introducerId: introducer_id,
          stateKey,
          body: {
            data: {
              requested_products: application.requested_products,
            },
          },
        });

      trackEvent(AMPLITUDE_EVENTS.initialApplicationCheckSubmitted, {
        'State key': stateKey,
      });

      return newApplication.data.application_id;
    }
  };

  return { initializeStateAndApplication };
};
